export default __webpack_public_path__ + "static/media/notification.19c17abb.jpg";